
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Crop, FileCopySharp, PlusOne } from '@material-ui/icons';
import { onlyInteger } from 'hooks/Pipe';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { wsCreate } from 'services/WService';
import Adornment from 'components/Tvendo/Common/Adornment';

import { useAuth } from 'hooks/useAuth';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  const [editRowId, setEditRowId] = useState(null);

  const { id, showNotify, oCDetails, setOCDetails, reload, ordenCompra } = props;
  const { hasPermission } = useAuth();
    
  let maxDiferencias = Math.max(...oCDetails.map(item => item.diferencia?.length || 0));
  if (maxDiferencias === 0) maxDiferencias = 1;

  const columns = [
    { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
    { Header: 'Cód. producto', accessor: 'ItemCode', width: 135 },
    { Header: 'Nombre producto', accessor: 'ItemName', width: 420 },
    { Header: 'Últ. p. compra', accessor: 'last_purchase_price', width: 130 },
    { Header: 'Und. medida', accessor: 'UM', width: 130 },
    { Header: 'Factor', accessor: 'Factor', width: 90 },
    { Header: 'Cantidad', accessor: 'Quantity', width: 100 },
  ];

  for (let i = 0; i < maxDiferencias; i++) {
    columns.push(
      { Header: `Cant. Sugerida ${i + 1}`, accessor: `modification_${i}`, width: 145 },
      { Header: `Comentario ${i + 1}`, accessor: `comment_${i}`, width: 330 }
    );
  }
  columns.push(
    { Header: 'Tasa (%)', accessor: 'VatPrcnt', width: 95 },
    { Header: 'Tot. sin IGV', accessor: 'LineTotal', width: 120 },
    { Header: 'Desc. IGV', accessor: 'VatSum', width: 100 },
    { Header: 'Tot. IGV', accessor: 'GTotal', width: 100 },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
  );

  const totalTableWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0);

  const handleChange2 = (id, field, value, index = 0) => {
    const i = oCDetails.findIndex(item => item.id === id);
    if (i === -1) return;

    const dif = oCDetails[i].diferencia || [];
    while (dif.length <= index) dif.push({});

    dif[index][field] = value;
    oCDetails[i].diferencia = dif;

    setOCDetails([...oCDetails]);
  };

  async function createComments(field, data) {
    setDataLoading(true);
    let payload = {
      [field]: data.value,
      purch_order_id: ordenCompra.id,
      purch_order_detail_id: data.purch_order_detail_id
    };

    let response = await wsCreate('purch/diferencia/store-clasic', payload);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado detallado de orden de compra para supervisor
          <span style={{ fontSize: '14px' }}>
            <b>{` (${ordenCompra.CardName || ''} - ${ordenCompra.WhsName || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
        <ReactTable
          exportExcel={false}
          formatDate="DD-MM-YYYY"
          columns={columns}
          defaultWidth={totalTableWidth}
          data={oCDetails.map((item, i) => {
            const row = {
              num: (
                <div className="actions-right">
                  {i + 1}
                </div>
              ),
              ItemCode: item.ItemCode,
              ItemName: item.ItemName,
              last_purchase_price: parseFloat(item.last_purchase_price).toFixed(4),
              UM: item.UM,
              Factor: item.Factor,
              Quantity: item.Quantity,
              VatPrcnt: item.VatPrcnt,
              LineTotal: currency(item.LineTotal),
              VatSum: currency(item.VatSum),
              GTotal: currency(item.GTotal),
              actions: ''
            };

            for (let j = 0; j < maxDiferencias; j++) {
              const diff = item.diferencia?.[j];
              let modificationField = null;
              let commentField = null;

              if (hasPermission(ConstantPermissions.PURCH_PURCHASES_UPDATE)) {
                modificationField = (
                  <TextField
                    fullWidth
                    name={`modification-${j}`}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    disabled={ordenCompra.state !== 'V'}
                    value={diff?.modification || ''}
                    InputProps={{
                      ...(diff ? {
                        endAdornment: (
                          <Adornment
                            title={`Creado por: ${diff?.usuario}`}
                            type="help"
                            placement="top"
                          />
                        )
                      } : {})
                    }}
                  />
                );
              } else if (hasPermission(ConstantPermissions.PURCH_PURCHASES_SUPERVISOR_INDEX)) {
                modificationField = (
                  <TextField
                    fullWidth
                    type="number"
                    name={`modification-${j}`}
                    margin="normal"
                    disabled={ordenCompra.state !== 'V'}
                    value={diff?.modification || ''}
                    onChange={(e) =>
                      handleChange2(item.id, 'modification', e.target.value, j)
                    }
                    onBlur={(e) => {
                      if (!diff) return;
                      createComments('modification', {
                        value: e.target.value,
                        purch_order_detail_id: item.id
                      });
                    }}
                    onKeyPress={onlyInteger}
                  />
                );
              }

              row[`modification_${j}`] = modificationField;


              if (hasPermission(ConstantPermissions.PURCH_PURCHASES_UPDATE)) {
                commentField = (
                  <TextField
                    fullWidth
                    name={`comment-${j}`}
                    margin="normal"
                    disabled={ordenCompra.state !== 'V'}
                    InputLabelProps={{ shrink: true }}
                    value={diff?.comment || ''}
                  />
                );
              } else if (hasPermission(ConstantPermissions.PURCH_PURCHASES_SUPERVISOR_INDEX)) {
                commentField = (
                  <TextField
                    fullWidth
                    type="text"
                    name={`comment-${j}`}
                    margin="normal"
                    disabled={ordenCompra.state !== 'V'}
                    value={diff?.comment || ''}
                    onChange={(e) =>
                      handleChange2(item.id, 'comment', e.target.value, j)
                    }
                    onBlur={(e) => {
                      if (!diff) return;
                      createComments('comment', {
                        value: e.target.value,
                        purch_order_detail_id: item.id
                      });
                    }}
                  />
                );
              }
              row[`comment_${j}`] = commentField;
            }
            return row;
          })}
        />
        </CardBody>
      </Card>
    </>
  );
});
